import React from 'react';
import { BsExclamationTriangle } from 'react-icons/bs';

export default function WarningModal({ message = "This is a warning!", onClose }) {
  // Close modal when clicking on overlay
  const handleOverlayClick = (e) => {
    // Only close if the click is directly on the overlay, not the modal content
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
      onClick={handleOverlayClick} // detect outside click
    >
      <div className="bg-white rounded-2xl shadow-lg w-96 p-6 flex flex-col items-center">
        {/* Warning Icon */}
        <div className="bg-red-100 p-4 rounded-full mb-4">
          <BsExclamationTriangle className="text-red-600 w-8 h-8" />
        </div>

        {/* Warning Title */}
        <h2 className="text-xl font-bold text-gray-800 mb-2">Warning!</h2>

        {/* Warning Message */}
        <p className="text-gray-600 text-center">{message}</p>

        {/* OK Button */}
        <button
          onClick={onClose} // Call onClose to hide modal
          className="mt-6 bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition"
        >
          OK
        </button>
      </div>
    </div>
  );
}
